var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "millestones" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12" }, [
          _c(
            "div",
            { staticClass: "projects row" },
            _vm._l(_vm.categories, function(c) {
              return c.isFeatured
                ? _c("div", { key: c.CategoryId, staticClass: "col-md-3" }, [
                    _c(
                      "div",
                      {
                        staticClass: "item",
                        on: {
                          click: function($event) {
                            return _vm.openCategory(c.url)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "image" }, [
                          _c("img", { attrs: { src: c.imageSquare } })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content" }, [
                          _c("h5", [_vm._v(_vm._s(c.name))])
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n              Encontre um projeto que toca seu coração e "),
        _c("span", [_vm._v("ajude como puder")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-657558c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657558c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/MillestonesSection.vue
// module id = null
// module chunks = 